import without from 'lodash/without';

let controllerRefs = [];

export const registerController = (controllerRef) => {
  controllerRefs.push(controllerRef);
};

export const unregisterController = (controllerRef) => {
  controllerRefs = without(controllerRefs, controllerRef);
};

export const forEachController = (callback) => {
  controllerRefs.forEach((controllerRef) => {
    callback(controllerRef);
  });
};
